// Figma: https://www.figma.com/design/iYlbYhvyJjh7X00UAcqCWt/About-page?node-id=121-4759
import { Box, Flex, Image, Text } from "@chakra-ui/react";
import { keyframes } from "@emotion/react";
import { aboutAsset } from "../aboutAssets";

const ceoPhoto = aboutAsset("henrik-02.jpg");

const shineSpin = keyframes`
  0% { background-position: 0 0; }
  100% { background-position: 200% 0; }
`;

const QUOTE =
  "\u201CComics are one of the most powerful storytelling formats in the world, but the way they\u2019re distributed and experienced hasn\u2019t kept up. GlobalComix is changing that. We\u2019re building a platform where fans can discover everything, creators can reach a global audience, and communities can form around the stories they love.\u201D";

export function CEOSection() {
  return (
    <Box maxW="960px" mx="auto" px={{ base: "16px", lg: "0" }} pt="24px">
      {/* Gradient container: solid charcoal at top, fades to transparent at bottom */}
      <Flex
        position="relative"
        isolation="isolate"
        direction="column"
        align="center"
        textAlign="center"
        gap="24px"
        w="100%"
        px={{ base: "24px", lg: "56px" }}
        pt={{ base: "48px", lg: "72px" }}
        pb={{ base: "40px", lg: "56px" }}
        borderRadius="24px"
        bgGradient="linear(180deg, #101112 59.62%, rgba(16, 17, 18, 0) 100%)"
        sx={{
          "&::before": {
            content: '""',
            position: "absolute",
            inset: 0,
            borderRadius: "24px",
            padding: "1px",
            background:
              "linear-gradient(180deg, rgba(255,255,255,0.08) 59.62%, rgba(255,255,255,0) 100%)",
            WebkitMask:
              "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
            WebkitMaskComposite: "xor",
            maskComposite: "exclude",
            pointerEvents: "none",
            zIndex: 1,
          },
        }}
      >
        {/* Eyebrow label */}
        <Text
          fontSize="14px"
          fontWeight="600"
          textTransform="uppercase"
          letterSpacing="0.2em"
          color="dune.dune"
        >
          From the CEO
        </Text>

        {/* Centered quote */}
        <Text
          fontSize={{ base: "18px", lg: "20px" }}
          fontWeight="400"
          color="dune.700"
          lineHeight="1.6"
          maxW="848px"
        >
          {QUOTE}
        </Text>

        {/* Attribution row: circular photo inline with name */}
        <Flex align="center" gap="16px">
          <Box
            position="relative"
            w="72px"
            h="72px"
            borderRadius="50%"
            overflow="hidden"
            isolation="isolate"
            flexShrink={0}
            border="1px solid rgba(255,255,255,0.20)"
            boxShadow="0 4px 16px rgba(0,0,0,0.4)"
            sx={{
              "&::before": {
                content: '""',
                position: "absolute",
                inset: 0,
                borderRadius: "50%",
                padding: "1px",
                background:
                  "radial-gradient(transparent, transparent, rgba(255,255,255,0.5), transparent, transparent)",
                backgroundSize: "200% 200%",
                WebkitMask:
                  "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
                WebkitMaskComposite: "xor",
                maskComposite: "exclude",
                animation: `${shineSpin} 6s linear infinite`,
                pointerEvents: "none",
                zIndex: 3,
              },
            }}
          >
            <Image
              src={ceoPhoto}
              alt="Henrik Rydberg, CEO"
              w="100%"
              h="100%"
              objectFit="cover"
              display="block"
            />
          </Box>
          <Text
            fontSize={{ base: "18px", lg: "20px" }}
            fontWeight="400"
            color="dune.700"
          >
            {"\u2013 Henrik Rydberg, CEO"}
          </Text>
        </Flex>
      </Flex>
    </Box>
  );
}
